import { ReportsCompanionControllerListChatTurnsData } from "@/client";
import { createPrefix } from "@/components/custom/table-view/search-namespace";
import { PreviewState } from "@/components/custom/data-table/data-table-preview";

/**
 * The chat log's table state lives in the companion route's URL under `cl_`, like any other table
 * here, so it cannot collide with the companion's own search params. `chatLog` says whether the
 * dialog is open, so a reload or a shared link reopens it on the same page and filters.
 */
export const chatLogNamespace = createPrefix<
  Partial<ReportsCompanionControllerListChatTurnsData> & {
    position?: number;
    preview?: PreviewState;
  }
>()("cl_");

export const CHAT_LOG_OPEN_PARAM = "chatLog";

type Search = Record<string, unknown>;

/**
 * The URL search that opens the chat log. `preselectAccountId` filters it to that account -- passed
 * for SuperAdmin only, the one role the endpoint applies an account filter for.
 */
export function openChatLogSearch(
  prev: Search,
  preselectAccountId?: number,
): Search {
  return {
    ...prev,
    [CHAT_LOG_OPEN_PARAM]: true,
    ...(preselectAccountId !== undefined
      ? { cl_accountIds: [preselectAccountId] }
      : {}),
  };
}

/** The URL search that closes the chat log: every chat-log key goes, so it reopens on page one. */
export function closeChatLogSearch(prev: Search): Search {
  return Object.fromEntries(
    Object.entries(prev).filter(
      ([key]) => key !== CHAT_LOG_OPEN_PARAM && !key.startsWith("cl_"),
    ),
  );
}
